<div *ngIf="portalProduct">
  <div class="rounded sub-card bg-white d-flex border">
    <div class="img-container me-3">
      <img alt="" class="product-image rounded" src="{{ portalProduct.PrimaryImage | contentImage : '6' }}" />
    </div>
    <div class="d-flex product-description-container flex-column">
      <div class="product-header d-flex">
        <div
          class="font-size-14 fw-bold"
          [ngClass]="{ 'text-primary': portalProduct.ProductType == 1, 'text-secondary': portalProduct.ProductType == 3 }"
        >
          {{ portalProduct.DisplayName }}
        </div>
        <span class="price-value ms-auto text-primary font-size-12 fw-bold">
          {{ portalProduct.MerchantPrice / 100 | FortressCurrencyPipe : currencyCode }}
        </span>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="font-size-12 subs-description" [innerHTML]="portalProduct.Description"></p>
        </div>
        <a class="font-size-12 fw-bold text-black learn-more">{{ 'subscription.list.item.learn.more' | translate }}</a>
      </div>
      <div class="action-buttons mt-auto">
        <button
          class="btn font-size-14 fw-bold w-100"
          [ngClass]="{ 'btn-primary': portalProduct.ProductType == 1, 'btn-secondary': portalProduct.ProductType == 3 }"
          (click)="openProductDescription(productInfo)"
        >
          <span>{{ 'subscription.upgrade.button' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!--Product info modal-->
<ng-template #productInfo let-modal>
  <div class="text-black bg-white">
    <div class="modal-body d-flex flex-column align-items-center">
      <a class="close-btn ms-auto" (click)="modal.dismiss()">
        <i class="material-icons text-info">close</i>
      </a>
      <img alt="" class="info-product-image rounded" src="{{ portalProduct.PrimaryImage | contentImage : '6' }}" />
      <label class="font-size-20 text-primary heading font-page-heading mb-2">{{ portalProduct.DisplayName }}</label>
      <span class="fw-bold font-size-14"> {{ portalProduct.MerchantPrice / 100 | FortressCurrencyPipe : currencyCode }}</span>
      <p class="mb-4 mt-3 font-size-12 portal-product-modal-description" [innerHTML]="portalProduct.Description"></p>

      <label class="font-size-14 mb-2 text-primary font-default">{{ 'subscription.modal.upgrade.label' | translate }}</label>
      <p class="font-size-14">{{ 'subscription.modal.upgrade.message' | translate }}</p>
      <div class="text-center mt-3">
        <button class="btn btn-primary close-info-btn fw-bold" (click)="addSubscriptionProductToCart(); modal.dismiss('close')">
          {{ 'subscription.modal.upgrade.button' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
